import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { ToDateTimeText, ToDateFullMonthText } from "../../utils/date";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
//Component
import { Modal } from "../../stories/modal";
import FormInput from "../../stories/hook-controls/input";
import { ReactTable } from "../../stories/react-table";
import * as alertDialog from "../../utils/alert";
//Function
import { getHistoryColumns } from "./columns/Column";
import { setDataToFormHookV2, isEmptyStr } from "../../utils/common-function";
import { formatDateTime } from "../../utils/common-function"
import { TextField, Divider } from "@material-ui/core";
import * as api from "./api";
import * as common from "./../../utils/common-function";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import { API_URL } from "../../utils/api-utils";
import BootstrapTable from 'react-bootstrap-table-next';

const useStyles = makeStyles((theme) => ({

    textLabel: {
        color: '#000',
        width: 140,
        marginBottom: '10px',
    },
    textLabelDetail: {
        width: 140,
        marginLeft: theme.spacing(2),
    },
    iconButtonActiveInactive: {
        // padding: 10,
        backgroundColor: '#000',
        color: '#fff',
        marginRight: theme.spacing(2),
      },
    textHistory: {
        color: '#000',
        fontWeight: 'bold',
        fontSize: 20,
        marginBottom: '5px'

    },
    buttonRigth:{
        textAlign: '-webkit-right'
    }
}));


function ViewHistory(props) {
    const classes = useStyles();
    const { open } = props;
    const { USER_ID,APP_ID,onEdit, ...otherprops } = props;

    const method = useForm();
    const { register, getValues } = method;
    const { setValue, setError, clearErrors, errors, control } = method;
    const [ViewHistory, setViewHistory] = useState([]);

    useEffect(() => {
        if (!open) return;
        if (typeof USER_ID === "undefined") return;

        fetch(USER_ID,APP_ID);

    }, [USER_ID,APP_ID, setValue, open]);

    const fetch = async (pUSER_ID,pAPP_ID) => {
        let param = { USER_ID: pUSER_ID, APPLICATION_ID : pAPP_ID };
        //console.log(param);
        let res = await api.GetViewDetailSPIAuthorizeByUser(param);
        setViewHistory(res);

    };



    const onDelete = async (pUSER_ID,pAPP_ID) => {

        let resConfirm = await alertDialog.ConfirmCommon("Do you want to delete user ?", "Yes", "No");
        if (!resConfirm) return;
    
        let param = { USER_ID: pUSER_ID , APPLICATION_ID : pAPP_ID };
        let res = await api.DeleteSPIUser(param);
        if (res.ResultCode === 10) { //Success
            alertDialog.SuccessShowButtonCloseModal("Delete Completed.", props);
            return;
        }
        else {
          alertDialog.ErrorDialog("Error : " + res.Message);
        }
    
      }
    return (
        <Modal
            {...otherprops}
            hiddenSave={true}
            //title="History Detail"
            maxWidth={false}
        >
            <BoxTemplate1 height="80vh" title="View Authorize">
                <Grid item xs={12} container spacing={1}  style={{ display: "flex", alignItems: "center" }}>
                    <Grid item xs={4} container spacing={1}>
                        <Grid item xs={3}>
                            <InputLabel id="simple-select-outlined-label" className={classes.textLabel} >UserName :</InputLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel id="simple-select-outlined-label" className={classes.textLabelDetail}>{ViewHistory?.USER_DETAIL?.USER_ID ?? ""}</InputLabel>
                        </Grid>
                    </Grid>
                    <Grid item xs={8} container spacing={1}>
                        <Grid item xs={8}>

                        </Grid>
                        <Grid item xs={4}  className={classes.buttonRigth}>
                            <Button variant="contained" className={classes.iconButtonActiveInactive}  onClick={() => onDelete(USER_ID,APP_ID)}>
                                Delete
                            </Button>
                            <Button variant="contained" className={classes.iconButtonActiveInactive} onClick={() => onEdit(USER_ID,APP_ID)} >
                                Edit
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} container spacing={1}>
                    <Grid item xs={4} container spacing={1}>
                        <Grid item xs={3}>
                            <InputLabel id="simple-select-outlined-label" className={classes.textLabel} >Application :</InputLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <InputLabel id="simple-select-outlined-label" className={classes.textLabelDetail}>{ViewHistory?.USER_DETAIL?.APP_NAME ?? ""}</InputLabel>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} container spacing={1}>
                    <Grid item xs={4} container spacing={1}>
                        <Grid item xs={3}>
                            <InputLabel id="simple-select-outlined-label" className={classes.textLabel} >SPI Purpose :</InputLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <InputLabel id="simple-select-outlined-label" className={classes.textLabelDetail}>{ViewHistory?.USER_DETAIL?.SPI_GROUP_NAME ?? ""}</InputLabel>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} container spacing={1}>
                    <Grid item xs={4} container spacing={1}>
                        <Grid item xs={3}>
                            <InputLabel id="simple-select-outlined-label" className={classes.textLabel} >Permission :</InputLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <InputLabel id="simple-select-outlined-label" className={classes.textLabelDetail}>{ViewHistory?.USER_DETAIL?.PERMISSION ?? ""}</InputLabel>
                        </Grid>
                    </Grid>
                </Grid>
                <br />
                <InputLabel id="simple-select-outlined-label" className={classes.textHistory} >History</InputLabel>
                <FormProvider>
                    {ViewHistory?.LIST_HISTORY?.length > 0 ?
                        (<ReactTable id="table_history"
                            keyField="HISTORY_ID"
                            data={ViewHistory?.LIST_HISTORY}
                            showSearch={false}
                            columns={getHistoryColumns()}
                        />) : <BootstrapTable keyField='HISTORY_ID' data={[]} columns={getHistoryColumns()} noDataIndication={'No results found'} />}
                </FormProvider>
            </BoxTemplate1>
        </Modal>
    );
}
export default ViewHistory;
